import GenericErrorTurnback from '../error/GenericErrorTurnback'

const Maintenance = () => {
  return (
    <GenericErrorTurnback
      mangoTurnBack={{
        variant: 'connection-error',
        title: 'Maintenance in progress',
        description: [
          <p key="1">We&apos;re currently conducting maintenance to improve the Humanforce Intelligence platform.</p>,
          <p key="2">Check the help centre to find out more about the current maintenance window</p>,
        ],
      }}
      mangoButton={{
        key: 'help-centre',
        testId: 'help-centre',
        variant: 'secondary',
        href: 'https://help.humanforce.com/hc/en-us',
        buttonText: 'Help Centre',
      }}
    />
  )
}

export { Maintenance }
